import { actionCreators } from "../../../../store/Parent";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, NavLink } from "react-router-dom";
import { Dispatch } from "redux";
import { FiUser, FiCreditCard, FiLock, FiLogOut } from "react-icons/fi";
import { Translate } from "../../../../helpers/Translate";
import { guardianAvatar, guardianName } from "./NavItemImage";

const iconStyle = (danger = false) => ({
  width: 32,
  height: 32,
  borderRadius: 8,
  flexShrink: 0,
  backgroundColor: danger ? "#fdecec" : "#e8f1f9",
  color: danger ? "#dc3545" : "#03589b",
});

const DropdownMenu = (props: any) => {
  let t = new Translate();
  const Navigate = useNavigate();

  const dispatch: Dispatch<any> = useDispatch();
  const guardian: any = useSelector((state: any) => state.Parent.guardian);

  const close = () => props.onClose?.();

  const LogOut = (e: any) => {
    dispatch(actionCreators.Logout());
    Navigate("/login");
  };

  const items = [
    { to: "/dashboard/viewprofile", icon: <FiUser />, label: "My Profile" },
    { to: "/dashboard/parentcard", icon: <FiCreditCard />, label: "View Card" },
    { to: "/dashboard/changepassword", icon: <FiLock />, label: "Change Password" },
  ];

  const name = guardianName(guardian);

  return (
    <div
      role="menu"
      className="position-absolute bg-white overflow-hidden"
      style={{
        top: "calc(100% + 10px)",
        insetInlineEnd: 0,
        width: 280,
        borderRadius: 14,
        border: "1px solid rgba(3, 88, 155, 0.08)",
        boxShadow: "0 16px 40px rgba(3, 40, 80, 0.18)",
        zIndex: 1050,
      }}
    >
      <div
        className="d-flex align-items-center gap-3 p-3"
        style={{ background: "linear-gradient(135deg, #f3f8fc 0%, #e6f0f9 100%)" }}
      >
        <img
          src={guardianAvatar(guardian)}
          width={48}
          height={48}
          className="rounded-circle"
          style={{ objectFit: "cover", boxShadow: "0 0 0 2px #fff, 0 0 0 4px #ffbd30" }}
          alt=""
        />
        <div className="overflow-hidden">
          {name && (
            <div className="fw-bold text-truncate" style={{ color: "#03589b" }}>
              {name}
            </div>
          )}
          {guardian?.username && (
            <div className="small text-muted text-truncate">{guardian.username}</div>
          )}
        </div>
      </div>

      <div className="py-2">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            role="menuitem"
            onClick={close}
            className="dropdown-item d-flex align-items-center gap-3 px-3 py-2"
            style={{ fontSize: 14 }}
          >
            <span className="d-flex align-items-center justify-content-center" style={iconStyle()}>
              {item.icon}
            </span>
            {t.translate(item.label)}
          </NavLink>
        ))}

        <hr className="my-2 mx-3" style={{ opacity: 0.1 }} />

        <NavLink
          to={"/login"}
          id="LogoutIdButton"
          role="menuitem"
          onClick={LogOut}
          className="dropdown-item d-flex align-items-center gap-3 px-3 py-2 text-danger fw-semibold"
          style={{ fontSize: 14 }}
        >
          <span className="d-flex align-items-center justify-content-center" style={iconStyle(true)}>
            <FiLogOut />
          </span>
          {t.translate("Logout")}
        </NavLink>
      </div>
    </div>
  );
};

export default DropdownMenu;
